<template>
    <v-overlay :value="loading || (isAuthenticated && !organizationsLoaded)" z-index="10000">
        <v-progress-circular
                indeterminate
                size="64"
        ></v-progress-circular>
    </v-overlay>
</template>

<script>
export default {
  name: "LoaderOverlay",
  computed: {
    loading() {
      return this.$store.getters.isLoading;
    },
    organizationsLoaded() {
      return this.$store.getters.isOrganizationsLoaded;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  }
};
</script>

<style scoped>

</style>